/**
 * @generated SignedSource<<008a11111c5ee5a2331cd18bfe1ff272>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateOptions_module$data = {
  readonly flow: {
    readonly name: string;
    readonly rowId: UUID;
    readonly " $fragmentSpreads": FragmentRefs<"TemplatesFavorite_flow">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AssignTemplateCardPopupModuleFragment">;
  readonly " $fragmentType": "TemplateOptions_module";
};
export type TemplateOptions_module$key = {
  readonly " $data"?: TemplateOptions_module$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateOptions_module">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateOptions_module",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssignTemplateCardPopupModuleFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "gwtUserId",
              "variableName": "gwtUserId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "TemplatesFavorite_flow"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Module",
  "abstractKey": null
};

(node as any).hash = "1bee8503bce5e7cecdc00f7cbdcb94f7";

export default node;
